import * as React from 'react';
import {FunctionComponent} from 'react';
import androidwebviewbeta from './../assets/browser-logos/android-webview-beta/android-webview-beta_32x32.png';
import androidwebviewcanary from './../assets/browser-logos/android-webview-canary/android-webview-canary_32x32.png';
import androidwebviewdev from './../assets/browser-logos/android-webview-dev/android-webview-dev_32x32.png';
import avant from './../assets/browser-logos/avant/avant_32x32.png';
import basilisk from './../assets/browser-logos/basilisk/basilisk.svg';
import bravebeta from './../assets/browser-logos/brave-beta/brave-beta.svg';
import bravedev from './../assets/browser-logos/brave-dev/brave-dev.svg';
import bravenightly from './../assets/browser-logos/brave-nightly/brave-nightly.png';
import brave from './../assets/browser-logos/brave/brave.svg';
import browsh from './../assets/browser-logos/browsh/browsh.svg';
import chromebeta from './../assets/browser-logos/chrome-beta/chrome-beta.svg';
import chromecanary from './../assets/browser-logos/chrome-canary/chrome-canary.svg';
import chromedev from './../assets/browser-logos/chrome-dev/chrome-dev.svg';
import chromium from './../assets/browser-logos/chromium/chromium.svg';
import dolphin from './../assets/browser-logos/dolphin/dolphin_32x32.png';
import ie from '../assets/images/ie.svg';
import edgebeta from './../assets/browser-logos/edge-beta/edge-beta_32x32.png';
import edgecanary from './../assets/browser-logos/edge-canary/edge-canary_32x32.png';
import edgedev from './../assets/browser-logos/edge-dev/edge-dev_32x32.png';
import edge from './../assets/browser-logos/edge/edge.svg';
import electron from './../assets/browser-logos/electron/electron.svg';
import falkon from './../assets/browser-logos/falkon/falkon.svg';
import facebook from '../assets/images/f_logo_RGB-Blue_58.png';
import firefoxbeta from './../assets/browser-logos/firefox-beta/firefox-beta.svg';
import firefoxdeveloperedition from './../assets/browser-logos/firefox-developer-edition/firefox-developer-edition.svg';
import firefoxlite from './../assets/browser-logos/firefox-lite/firefox-lite.svg';
import firefoxnightly from './../assets/browser-logos/firefox-nightly/firefox-nightly.svg';
import firefoxreality from './../assets/browser-logos/firefox-reality/firefox-reality.svg';
import firefox from './../assets/browser-logos/firefox/firefox.svg';
import geckoview from './../assets/browser-logos/geckoview/geckoview.svg';
import hermes from './../assets/browser-logos/hermes/hermes.svg';
import icecat from './../assets/browser-logos/icecat/icecat_32x32.png';
import jsdom from './../assets/browser-logos/jsdom/jsdom.svg';
import konqueror from './../assets/browser-logos/konqueror/konqueror.svg';
import maxthon from './../assets/browser-logos/maxthon/maxthon_32x32.png';
import midori from './../assets/browser-logos/midori/midori.svg';
import netsurf from './../assets/browser-logos/netsurf/netsurf.svg';
import operabeta from './../assets/browser-logos/opera-beta/opera-beta_32x32.png';
import operadeveloper from './../assets/browser-logos/opera-developer/opera-developer_32x32.png';
import operagx from './../assets/browser-logos/opera-gx/opera-gx.svg';
import operaminibeta from './../assets/browser-logos/opera-mini-beta/opera-mini-beta_32x32.png';
import operamini from './../assets/browser-logos/opera-mini/opera-mini_32x32.png';
import operaneon from './../assets/browser-logos/opera-neon/opera-neon_32x32.png';
import operatouch from './../assets/browser-logos/opera-touch/opera-touch_32x32.png';
import opera from './../assets/browser-logos/opera/opera.svg';
import otter from './../assets/browser-logos/otter/otter.svg';
import palemoon from './../assets/browser-logos/pale-moon/pale-moon_32x32.png';
import puffin from './../assets/browser-logos/puffin/puffin_32x32.png';
import qutebrowser from './../assets/browser-logos/qutebrowser/qutebrowser.svg';
import safariios from './../assets/browser-logos/safari-ios/safari-ios.svg';
import safaritechnologypreview
  from './../assets/browser-logos/safari-technology-preview/safari-technology-preview_32x32.png';
import safari from './../assets/browser-logos/safari/safari_32x32.png';
import samsunginternetbeta from './../assets/browser-logos/samsung-internet-beta/samsung-internet-beta_32x32.png';
import samsunginternet from './../assets/browser-logos/samsung-internet/samsung-internet.svg';
import seamonkey from './../assets/browser-logos/seamonkey/seamonkey_32x32.png';
import servo from './../assets/browser-logos/servo/servo.svg';
import silk from './../assets/browser-logos/silk/silk_32x32.png';
import sogoumobile from './../assets/browser-logos/sogou-mobile/sogou-mobile_32x32.png';
import toralpha from './../assets/browser-logos/tor-alpha/tor-alpha_32x32.png';
import tornightly from './../assets/browser-logos/tor-nightly/tor-nightly_32x32.png';
import tor from './../assets/browser-logos/tor/tor_32x32.png';
import ucmini from './../assets/browser-logos/uc-mini/uc-mini_32x32.png';
import uc from './../assets/browser-logos/uc/uc_32x32.png';
import v8ignition from './../assets/browser-logos/v8-ignition/v8-ignition.svg';
import v8liftoff from './../assets/browser-logos/v8-liftoff/v8-liftoff.svg';
import v8orinoco from './../assets/browser-logos/v8-orinoco/v8-orinoco.svg';
import v8turbofan from './../assets/browser-logos/v8-turbofan/v8-turbofan.svg';
import v8 from './../assets/browser-logos/v8/v8.svg';
import vivaldisnapshot from './../assets/browser-logos/vivaldi-snapshot/vivaldi-snapshot_32x32.png';
import vivaldi from './../assets/browser-logos/vivaldi/vivaldi.svg';
import web from './../assets/browser-logos/web/web.svg';
import webkitnightly from './../assets/browser-logos/webkit-nightly/webkit-nightly_32x32.png';
import webkit from './../assets/browser-logos/webkit/webkit.svg';
import yandexalpha from './../assets/browser-logos/yandex-alpha/yandex-alpha_32x32.png';
import yandexbeta from './../assets/browser-logos/yandex-beta/yandex-beta_32x32.png';
import yandexlite from './../assets/browser-logos/yandex-lite/yandex-lite_32x32.png';
import yandex from './../assets/browser-logos/yandex/yandex_32x32.png';

import chrome from './../assets/browser-logos/chrome/chrome.svg';

const browserLogos: BrowserLogos = {
  androidwebviewbeta: androidwebviewbeta,
  androidwebviewcanary: androidwebviewcanary,
  androidwebviewdev: androidwebviewdev,
  chromemobilewebview: androidwebviewdev,
  avant: avant,
  basilisk: basilisk,
  bravebeta: bravebeta,
  bravedev: bravedev,
  bravenightly: bravenightly,
  brave: brave,
  browsh: browsh,
  chromebeta: chromebeta,
  chromecanary: chromecanary,
  chromedev: chromedev,
  chrome: chrome,
  chromemobileios: chrome,
  chromemobile: chrome,
  chromium: chromium,
  dolphin: dolphin,
  edgebeta: edgebeta,
  edgecanary: edgecanary,
  edgedev: edgedev,
  edge: edge,
  electron: electron,
  falkon: falkon,
  facebook: facebook,
  firefoxbeta: firefoxbeta,
  firefoxmobile: firefox,
  firefoxdeveloperedition: firefoxdeveloperedition,
  firefoxlite: firefoxlite,
  firefoxnightly: firefoxnightly,
  firefoxreality: firefoxreality,
  firefox: firefox,
  geckoview: geckoview,
  hermes: hermes,
  icecat: icecat,
  ie: ie,
  IE: ie,
  jsdom: jsdom,
  konqueror: konqueror,
  maxthon: maxthon,
  midori: midori,
  netsurf: netsurf,
  operabeta: operabeta,
  operadeveloper: operadeveloper,
  operagx: operagx,
  operaminibeta: operaminibeta,
  operamini: operamini,
  operaneon: operaneon,
  operatouch: operatouch,
  opera: opera,
  otter: otter,
  palemoon: palemoon,
  puffin: puffin,
  qutebrowser: qutebrowser,
  safariios: safariios,
  safaritechnologypreview: safaritechnologypreview,
  safari: safari,
  mobilesafari: safari,
  samsunginternetbeta: samsunginternetbeta,
  samsunginternet: samsunginternet,
  seamonkey: seamonkey,
  servo: servo,
  silk: silk,
  sosogoumobile: sogoumobile,
  toralpha: toralpha,
  tornightly: tornightly,
  tor: tor,
  ucmini: ucmini,
  uc: uc,
  v8ignition: v8ignition,
  v8liftoff: v8liftoff,
  v8orinoco: v8orinoco,
  v8turbofan: v8turbofan,
  v8: v8,
  vivaldisnapshot: vivaldisnapshot,
  vivaldi: vivaldi,
  web: web,
  webkitnightly: webkitnightly,
  webkit: webkit,
  yandexalpha: yandexalpha,
  yandexbeta: yandexbeta,
  yandexlite: yandexlite,
  yandex: yandex
};

export interface BrowserLogoProps {
  name?: string | null | undefined;
  className?: string | undefined;
}

interface BrowserLogos {
  [key: string]: string | undefined;
}

function browserLogo(name: string): any {
  name = name.toLowerCase().replace(/\s/g, '');
  return browserLogos[name] ? browserLogos[name] : browserLogos['web'];
}


export const BrowserLogo: FunctionComponent<BrowserLogoProps> = ({name, className}) => {
  if (!name) {
    name = 'web';
  }
  const logo = browserLogo(name);
  //: <span className={className}>{name}</span>;
  return <img style={{bottom: 2}} src={logo} className={className} alt={name} title={name} />;
};
